import { Link } from "react-router-dom";

const ServerMaintenance = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-20 bg-gradient-to-b from-slate-950 via-slate-900 to-black text-white">
      <div className="w-full max-w-4xl rounded-[2rem] border border-white/10 bg-white/5 backdrop-blur-xl shadow-2xl shadow-slate-950/40 ring-1 ring-white/10 p-10 sm:p-14">
        <div className="flex flex-col gap-6">
          <div className="inline-flex items-center gap-3 px-4 py-2 text-xs font-semibold uppercase tracking-[0.3em] text-amber-200 rounded-full bg-amber-500/10">
            <span className="inline-flex w-2 h-2 rounded-full bg-amber-300 animate-pulse"></span>
            서버 점검 중
          </div>

          <div className="max-w-3xl space-y-4">
            <h1 className="text-4xl font-black tracking-tight sm:text-5xl">
              잠시만 기다려주세요.
            </h1>
            <p className="text-base leading-8 text-slate-200 sm:text-lg">
              현재 MinDevX 서버 점검이 진행 중입니다. 빠른 시일 내에 정상 서비스로 돌아올 예정이며, 다시 이용할 수 있을 때까지 감사합니다.
            </p>
          </div>

          <div className="grid gap-4 sm:grid-cols-[1fr_auto]">
            <Link
              to="/ping"
              className="inline-flex items-center justify-center rounded-3xl bg-indigo-500 px-6 py-3 text-sm font-semibold text-white shadow-xl shadow-indigo-500/20 transition hover:bg-indigo-400"
            >
              서버 상태 확인
            </Link>
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-3xl border border-white/10 bg-white/10 px-6 py-3 text-sm font-semibold text-white transition hover:bg-white/20"
            >
              홈으로 돌아가기
            </Link>
          </div>

          <div className="grid gap-4 sm:grid-cols-3">
            <div className="rounded-3xl bg-slate-900/70 p-4 text-sm text-slate-200 ring-1 ring-white/10">
              <p className="font-semibold text-white">예상 복구</p>
              <p className="mt-2">10분 이내</p>
            </div>
            <div className="rounded-3xl bg-slate-900/70 p-4 text-sm text-slate-200 ring-1 ring-white/10">
              <p className="font-semibold text-white">지원</p>
              <p className="mt-2">문의는 깃허브 리포지토리</p>
            </div>
            <div className="rounded-3xl bg-slate-900/70 p-4 text-sm text-slate-200 ring-1 ring-white/10">
              <p className="font-semibold text-white">최신 상태</p>
              <p className="mt-2">자동으로 새로 고침됩니다</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServerMaintenance;